import React, { useEffect, useRef, useState } from "react";
import Header from "../../../components/global/Header";
import LeftNavbar from "../../../components/global/LeftNavbar";
import {  useTranslation } from 'react-i18next';
import { getAxiosResponse,postAxiosResponse,deleteAxiosResponse ,putAxiosResponse} from '../../../services/authApiRoutes/APImethods';
import APIUrls from '../../../services/APIUrls';
import DataTable from "react-data-table-component";
import { useSelector } from 'react-redux'
import Constants from "../../../Constants";
import $, { event } from "jquery";
import { transformBlankToNull } from '../../../services/Util';
import { useNavigate } from 'react-router-dom';
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/dashboard/Breadcrumb";
import { handleError } from "../../../services/authApiRoutes/APImethods";

export default function ProjectSettingProjectTag() {
    const scrollRef = useRef(null);
    const { t } = useTranslation();
    const  [pageNumber,setPageNumber]=useState()
    const  [projectTags,setProjectTags]=useState([])
    const  [projecTagsData,setProjectTagsData]=useState([])
    const  [renameTag,setRenameTag]=useState({})
    const  [renameTagRes,setRenameTagRes]=useState("")
    const  [tagId,setTagId]=useState(null)
    const  [tagDelete,setTagDelete]=useState(null)
    const  [newTag,setNewTagName]=useState(null)
    const  [newTagRes,setNewTagRes]=useState(null)
    const  [validTags,setValidTags]=useState(false)
  const [totalRows, setTotalRows] = useState(0);
   const [perPage, setPerPage] = useState(10);
    const  [renameValidation,setRenameValidation]=useState(false)
    const  navigate = useNavigate();
    const[globalOverlay,showGlobalOverlay] = useState(true);
    const focusRef = useRef();
    const [pending, setPending] = useState(false);

    const [sort, setSort] = useState("");
  
	const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
    const translate = t;
    const showModel = () => {
        setconintendent(true);
        document.body.classList.add("modal-open");
        setTimeout(() => {
          $(".first-focus").trigger("focus");
          $(".first-focus").on("keydown", function (e) {
            if (e.key === Constants.TAB) {
              if (e.shiftKey === true) {
                e.preventDefault();
                $("#renameId").trigger("focus");
              }
            }
          });
          $(".inner-lightbox-panel").on("keydown", function (e) {
            if (e.key === Constants.ESCAPE) {
              hideIntendentModel();
              $('.focusAdd').trigger('focus');
              $('.inline-flex').removeClass('focusAdd');
            }
          });
        }, 500);
      };
      const handleKeyDeleteflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $(".first-focus").trigger("focus");
          }
        }
      };

      useEffect(()=>{
        $(".lastdisable").trigger("focus");
      }, [])
      
      const backToProject=()=>{
        navigate("/settings")
      }

      const hideModel = () => {
        document.body.classList.remove("modal-open");
      };
     
      const showIntendentModel = () => {
        setconintendent(false);
        document.body.classList.add("modal-open");
        setTimeout(() => {
          $(".first-focus").trigger("focus");
          $("#renameInput").on("keydown", function (e) {
            if (e.key === Constants.TAB) {
             if (e.shiftKey === true) {
                e.preventDefault();
                $("#SaveId").trigger("focus");
              }
            }
          });
          $(".inner-lightbox-panel").on("keydown", function (e) {
            if (e.key === Constants.ESCAPE) {
             hideIntendentModel();
              $('.focusAdd').trigger('focus');
              $('.inline-flex').removeClass('focusAdd');
            }
          });
        }, 500);
      };
      const handleKeyEditflow = (event) => {
        if (event.key === Constants.TAB) {
          if (event.shiftKey === false) {
            event.preventDefault();
            $("#renameInput").trigger("focus");
          }
        }
      };
      const hideIntendentModel = () => {
        document.body.classList.remove("modal-open");
     };

     useEffect(()=>{
      setPageNumber(1)
     },[])

     useEffect(()=>{
      getAllTags()
      showGlobalOverlay(false)
     },[pageNumber,tagDelete,newTagRes,renameTagRes,sort])

     const setProjectSettingTagsDataIndex=(index,tagName,id)=>{
      setRenameTag({tag:tagName,id:id})
      setRenameValidation(false)
     }

     const noDataFoundComponent = () => {
      return (<div role="rowgroup">
      <div role="row" className="no-data-display align-center">
        <div role="cell">
          <i className="nodata-icon"></i>
          <p>{Constants.NO_RECORD_FOUND}</p>
        </div>
      </div>
    </div>);
    
  }

  const setNewTagData=(event)=>{
    setNewTagName(event?.target?.value)
    setValidTags(false)
  }
  
  
   const addNewTag= ()=>{
    showGlobalOverlay(true)
     let obj={display:newTag}
      postAxiosResponse(APIUrls.TAGS,obj).then(res=>{
      if (res.data.code === 200) {
        setNewTagRes(res.data.code)
        setNewTagName(null)
        getAllTags()
      }else{
       setValidTags(true)
      }
      showGlobalOverlay(false)
     }).catch(err=>{
      console.error(err)
      showGlobalOverlay(false)
     })
   }

   const btnDisable=()=>{
    if(newTag==="" || newTag===null){
      return true
    }
    return false;
   }


   const btnDisableRenameTag=()=>{
    if(renameTag?.tag==="" || renameTag?.tag===null){
      return true
    }
    return false;
   }

   const saveRenameTag=(id)=>{
    showGlobalOverlay(true)
    let obj=projecTagsData.filter(data=> data.id ===renameTag.id)
     obj=obj[0]
     let finalObj={...obj,['display']:renameTag.tag} 
     putAxiosResponse(APIUrls.PROJECT_TAGS(obj.id),transformBlankToNull(finalObj)).then(res=>{
      if(res.data.code===200){
        setRenameTagRes(res)
        hideModel()
      }else{
        setRenameValidation(true)
      }

      showGlobalOverlay(false)
    }).catch(err => {
      handleError(err);

      showGlobalOverlay(false)
    });
   }
     const getAllTags=()=>{
      let  url=APIUrls.TAGS+`?page=${pageNumber}&pageSize=${perPage}${sort}`
     getAxiosResponse(url).then(result=>{
      if(result?.data?.data?.result && result?.data?.data?.result.length > 0){
        const finalData=result?.data?.data?.result.map(data=>{
          return {
            tag:data.display,
            project:data.projectCount ,
            projectRequests:data.projectRequestCount,
            campaigns:data.workspaceCount ,
            id:data.id
          }
        })
      setProjectTagsData(result?.data?.data?.result)
      setProjectTags(finalData)
      setTotalRows(result?.data?.data?.resultCount);
      setPending(false)
      }else{
      setProjectTags([])
      }
      setPending(false)
     }).catch(err=>{
      console.error(err)
      setPending(false)
     })

     }


     const handlePerRowsChange = async (newPerPage, page) => {
      let  url=APIUrls.TAGS+`?page=${pageNumber}&pageSize=${newPerPage}${sort}`
      let result=await getAxiosResponse(url)
      if(result?.data?.data?.result && result?.data?.data?.result.length > 0){
        const finalData=result?.data?.data?.result.map(data=>{
          return {
            tag:data.display,
            project:data.projectCount,
            projectRequests:data.projectRequestCount ,
            campaigns:data.workspaceCount,
            id:data.id
          }
        })
      setProjectTagsData(result?.data?.data?.result)
      setPerPage(newPerPage);
      setProjectTags(finalData)
      setTotalRows(result?.data?.data?.resultCount);
      }
    };
  

     const deleteTag=(id)=>{
      showGlobalOverlay(true)
      deleteAxiosResponse(APIUrls.PROJECT_TAGS(id)).then(res=>{
        if (res.data.code === 200) {
          setTagDelete(id)
         showGlobalOverlay(false)
          hideModel()
				}
      })
     }
     const handleSort = (column, sortDirection) => {
      var order = sortDirection.toUpperCase();
      var sortedColumn = column.id;
      var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
      $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']")
        .attr({ 'aria-label': column.name, 'aria-sort': order === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING });
      setSort(sortedString);
    };
     const columns = [
      {  
        id: "tagInfo.display",
        name: 'Tag',
        selector:(row) => row.tag,
        sortable: true,
      },
      {  
        id:"tagInfo.projectCount",
        name: 'Project',
        sortable: true,
        selector:(row) => row.project > 0 ?row.project ===1? row.project+" Project":row.project+" Projects" : "No projects",
        cell: (row) =>row.project==="No projects"?row.project:(
          <>
          {row.project > 0 ?<Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/projects?tag=${row.tag}&id=${row.id}`}
          >
           {row.project ===1? row.project+" Project":row.project+" Projects" }
          </Link>: "No projects"}</>
       ),
    },
      {
        id:"tagInfo.projectRequestCount",
        name: 'Project Requests',
        selector:(row) => row.projectRequests,
        sortable: true,
        cell: (row) =>row.projectRequests==="No requests"?row.projectRequests:(
          <>
         {row.projectRequests > 0 ?
          <Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/project-request/list?tag=${row.tag}&id=${row.id}`}
          >
            {row.projectRequests+" requests" }
          </Link>:"No requests"}
          </>
       ),
      },{
        id:"tagInfo.workspaceCount",
        name: 'Campaigns',
        selector:(row) => row.campaigns,
        sortable: true,
        cell: (row) =>row.campaigns==="No campaigns"?row.campaigns:(
          <>
          {row.campaigns > 0 ?
          <Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/campaigns?tag=${row.tag}&id=${row.id}`}
          >
            {row.campaigns ===1?row.campaigns + " Campaign":row.campaigns + " Campaigns"}
          </Link>:"No campaigns"}
          </>
       ),
      },
      {
        name: 'Action',
        selector:(row,index) =><>
              <button type="button"  className="mr-15 inline-flex" aria-label="delete" onClick={showModel}>
      <svg onClick={()=>setTagId(row.id)} className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M11.0599 2.33973C11.3056 2.58546 11.4573 2.90766 11.4917 3.25039H8.50673C8.54117 2.90766 8.69283 2.58546 8.93856 2.33973C9.21986 2.05843 9.60139 1.90039 9.99922 1.90039C10.397 1.90039 10.7786 2.05843 11.0599 2.33973ZM7.94861 1.34978C7.44021 1.85818 7.14008 2.5359 7.1031 3.25039H1.74922C1.56357 3.25039 1.38552 3.32414 1.25424 3.45542C1.12297 3.58669 1.04922 3.76474 1.04922 3.95039C1.04922 4.13604 1.12297 4.31409 1.25424 4.44537C1.38552 4.57664 1.56357 4.65039 1.74922 4.65039H2.77494L4.07301 15.896C4.17007 16.7369 4.57287 17.5127 5.20477 18.0759C5.83666 18.6391 6.65356 18.9503 7.50001 18.9504H12.4984C13.3449 18.9503 14.1618 18.6391 14.7937 18.0759C15.4256 17.5127 15.8284 16.7369 15.9254 15.896L17.2235 4.65039H18.2492C18.4349 4.65039 18.6129 4.57664 18.7442 4.44537C18.8755 4.31409 18.9492 4.13604 18.9492 3.95039C18.9492 3.76474 18.8755 3.58669 18.7442 3.45542C18.6129 3.32414 18.4349 3.25039 18.2492 3.25039H12.8953C12.8584 2.5359 12.5582 1.85818 12.0498 1.34978C11.506 0.805925 10.7683 0.500391 9.99922 0.500391C9.23009 0.500391 8.49246 0.805925 7.94861 1.34978ZM6.13615 17.0311C5.76064 16.6966 5.52118 16.2358 5.46333 15.7362C5.46333 15.7362 5.46333 15.7362 5.46332 15.7361L4.18462 4.65039H15.8138L14.5351 15.7361C14.4773 16.2357 14.2378 16.6966 13.8623 17.0311C13.4868 17.3657 13.0014 17.5505 12.4984 17.5504H7.50002C6.99708 17.5505 6.51168 17.3657 6.13615 17.0311ZM8.84419 7.30542C8.71292 7.17414 8.53487 7.10039 8.34922 7.10039C8.16357 7.10039 7.98552 7.17414 7.85424 7.30542C7.72297 7.43669 7.64922 7.61474 7.64922 7.80039V14.4004C7.64922 14.586 7.72297 14.7641 7.85424 14.8954C7.98552 15.0266 8.16357 15.1004 8.34922 15.1004C8.53487 15.1004 8.71292 15.0266 8.84419 14.8954C8.97547 14.7641 9.04922 14.586 9.04922 14.4004V7.80039C9.04922 7.61474 8.97547 7.43669 8.84419 7.30542ZM12.3492 7.80039C12.3492 7.61474 12.2755 7.43669 12.1442 7.30542C12.0129 7.17414 11.8349 7.10039 11.6492 7.10039C11.4636 7.10039 11.2855 7.17414 11.1542 7.30542C11.023 7.43669 10.9492 7.61474 10.9492 7.80039V14.4004C10.9492 14.586 11.023 14.7641 11.1542 14.8954C11.2855 15.0266 11.4636 15.1004 11.6492 15.1004C11.8349 15.1004 12.0129 15.0266 12.1442 14.8954C12.2755 14.7641 12.3492 14.586 12.3492 14.4004V7.80039Z" fill="#1D4ED8" stroke="#1D4ED8" strokeWidth="0.3"/>
      </svg>
      </button>
      <button  type="button" className="inline-flex" aria-label="edit" onClick={showIntendentModel}>
        <svg onClick={()=>setProjectSettingTagsDataIndex(index,row.tag,row.id)} className="aaa-change-icon" xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
          <path d="M15.2521 4.97331C15.6144 4.61106 15.8137 4.12997 15.8137 3.61822C15.8137 3.10647 15.6144 2.62539 15.2521 2.26314L13.7322 0.743224C13.3699 0.380974 12.8889 0.181641 12.3771 0.181641C11.8654 0.181641 11.3843 0.380974 11.023 0.742266L0.833984 10.8996V15.1307H5.06311L15.2521 4.97331ZM12.3771 2.09831L13.898 3.61727L12.3742 5.13526L10.8543 3.61631L12.3771 2.09831ZM2.75065 13.214V11.6951L9.49732 4.96947L11.0172 6.48939L4.27153 13.214H2.75065ZM0.833984 17.0473H16.1673V18.964H0.833984V17.0473Z" fill="#1D4ED8"/>
          </svg>
      </button>
        
        </>,
      },
      
    ];
    const theme = aaaSelected ? "dark" : "";
     const [conintendent, setconintendent] = useState(false);

     const handlePageChange = (paging) => {
       setPageNumber(paging); 
      //$('#pagination-next-page').trigger('focus')
    };
       $(document).on("click",".datatable-block .rdt_TableCell button.inline-flex",function() {
         $(this).addClass('focusAdd');
      });
      $(document).on("click",".modal-footer .btn",function() {
        $('.focusAdd').trigger('focus');
        $('.inline-flex').removeClass('focusAdd');
      });
     $(".rdt_Table").attr("aria-label","Project Tags"); 
     $(document).ready(function(){
      $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
      $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
     })
  //    $(document).on("click",".rdt_Pagination button",function() {
      
  //  });
  const crumbs = [
    {label:'Settings', url:'settings'},
    {label:'Project tags', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
             <div className="project-setting-page">
                <div className="project-heading userprofile-heading">
                    <div className="back-arrow flex-center">
                    <button aria-label="back" onClick={()=> navigate("/settings")} ref={focusRef}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none">
                        <path d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z" fill="#1D4ED8"/>
                        </svg>
                    </button>
                    <span>Back to Settings</span>
                    </div>
                    <h3 className="flex">Project Tags</h3>
                    <span>Manage, browse, and edit your project tags</span>
                </div>
                <div className="white-bg"> 
                    <div className="wrap-input-text-group mar-bot30">
                        <label>Add New Tag</label>
                        <div className="input-text-group flex ">
                          <input onChange={(event)=>setNewTagData(event)} name="display" type="text" value={newTag===null?"":newTag}  className="form-control-sm" title="Add new tag" />
                          <button disabled={btnDisable() } onClick={addNewTag}  className={btnDisable() ?"blue-btn active":"blue-btn active"}>Add</button> 
                        </div>
                        {newTag==="" ?<span className="textDanger">Empty tag code passed</span>:""}
                        {validTags?<span className="textDanger">The tag cannot be created because a tag by that name already exists.</span>:""}
                    </div>
                   
                <div className="datatable-block">
                   <DataTable
										columns={columns}
										data={projectTags}
										pagination
										highlightOnHover
                    onSort={handleSort}
										responsive
										theme={theme}
										selectableRowsHighlight={true}
										keyField="id"
										paginationServer
										onChangePage={handlePageChange}
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationRowsPerPageOptions={[10,20,30,50,100]}
                    noDataComponent={noDataFoundComponent()}
										progressPending={pending}
									/>
                 </div>
                    
                </div> 
             </div>
          </div>
        </section>
      </div>

{conintendent ? 
         <div className='lightbox-panel' aria-labelledby="removelabel" aria-modal="true" role="dialog">
            <div className="inner-lightbox-panel pb-0">
            <div className="modal-header flex padd-lr">
              <h5 id="removelabel">Remove Tag</h5>
             </div>
             <div className="lightbox-content padd-22">
               <p className="f16-para">
               Are you sure you want to remove this tag? Removing a tag also removes the tag from any project(s) it is attached to.
               </p>
             </div>	
             <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus" onClick={hideModel}>Cancel</button>
                    <button onClick={()=>deleteTag(tagId)} className="btn btn-bold active" onKeyDown={handleKeyDeleteflow} id="renameId">Remove</button>
            </div>
            </div>		
          </div> :

            <div className='lightbox-panel' aria-labelledby="renamelabel" aria-modal="true" role="dialog">
                <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
                <div className="modal-header flex padd-lr">
                <h5 id="renamelabel">Rename Tag</h5>
                </div>
                <div className="lightbox-content padd-22">
                    <p className="f16-para">To change the name of this tag, please enter the new name below.</p>
                   <div className="flex wrap-dropdown mb-0">
                     <div className="global-dropdown-block">
                        <label>Rename Tag</label>
                        <input id="renameInput" onChange={(event)=>{setRenameTag({...renameTag ,tag:event?.target?.value});setRenameValidation(false)}} type="text" value={renameTag.tag} className="form-control-sm" title="Rename Tag" />
                     </div>
                    {renameValidation? <span  className="textDanger">The tag cannot be renamed because another tag with the same name already exists</span>:""}
                    </div>
                </div>
       
                <div className="modal-footer modal-footer-border flex px-22">
                    <button className="btn btn-bold first-focus" onClick={hideIntendentModel}>Cancel</button>
                    <button disabled={btnDisableRenameTag()} onClick={saveRenameTag} onKeyDown={handleKeyEditflow} className={btnDisable() ?"blue-btn active":"blue-btn active"} id="SaveId">Save</button>
                </div>
                </div>		
            </div>

     }
     <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
            <div>
             <button onClick={backToProject} className="btn-default">Cancel</button>
            </div>
        </div>
     </div>
     <div className={globalOverlay ? "gb-overlay show" : "gb-overlay hide"}>
      <div className="gb-loader">
          <RotatingLines
            strokeColor="#0096FF"
            strokeWidth="5"
            width="196"
            visible={true}
          />
        </div>
      </div>  
    </div>
  );
}
